import { OptionsObject } from 'notistack'

const commonNotificationSettings: OptionsObject = {
  preventDuplicate: true,
  autoHideDuration: 3750,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
}

export const DEFAULT_NOTIFICATION: OptionsObject = {
  ...commonNotificationSettings,
  variant: 'default', // notifications are all black for now according to UX
}

export const ERROR_NOTIFICATION: OptionsObject = {
  ...commonNotificationSettings,
  variant: 'default', // notifications are all black for now according to UX
}

export const SUCCESS_NOTIFICATION: OptionsObject = {
  ...commonNotificationSettings,
  variant: 'default', // notifications are all black for now according to UX
}

export const INFO_NOTIFICATION: OptionsObject = {
  ...commonNotificationSettings,
  variant: 'default', // notifications are all black for now according to UX
}
